module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-5-small-cd6b38143f49716b2778826143d9eb2f.jpg";